/**
 * A class represents a capability of a particular employee.
 */
import { CapabilityType } from '../../enums/CapabilityType';

export class Capability {
  types: CapabilityType[];
  startDate: string;

  /**
   * @param types the capabilities that are assigned to the employee.
   * @param startDate the Monday from which this capability takes effect.
   */
  constructor(types: CapabilityType[], startDate: string) {
    this.types = types;
    this.startDate = startDate;
  }
}
